<template>
  <div class="flex flex-col items-center justify-center h-full space-y-2.5 my-auto px-3 !pt-0">
    <div
      class="flex flex-col p-6 w-full md:w-3/4 lg:w-1/2 mx-auto border shadow-xl rounded-lg 2xl:w-1/3 bg-white"
    >
      <div class="flex items-center space-x-10 justify-center">
        <img
          src="/images/logo-clear.png"
          class="w-32"
        >

        <div>
          <h1 class="text-2xl font-semibold break-words w-min my-auto">
            Construction Commercial Management
          </h1>

          <p class="font-bold text-ccm-blue-500">
            <span class="font-bold text-[#bb6101]">Get Control</span>

            <br class="sm:hidden">

            <span class="font-bold text-ccm-blue-500">
              Keep Control
            </span>
          </p>
        </div>
      </div>

      <form
        v-if="!success"
        class="flex flex-col space-y-6 w-4/5 mx-auto mt-6"
        @submit.prevent="resetPassword"
      >
        <h2 class="text-2xl md:text-3xl font-semibold break-words text-center text-gray-800">
          {{ $t('PasswordReset.title') }}
        </h2>

        <label>
          {{ $t('PasswordReset.label.email') }}
          <AppInput
            v-model="passwordResetForm.form.email"
            class="read-only:bg-gray-200 form-input"
            type="email"
            name="email"
            :error="passwordResetForm.getErrors('email')"
            readonly
          />
        </label>

        <label>
          {{ $t('PasswordReset.label.password') }}

          <AppInput
            v-model="passwordResetForm.form.password"
            class="form-input"
            type="password"
            name="password"
            :error="passwordResetForm.getErrors('password')"
            required
          />
        </label>

        <label>
          {{ $t('PasswordReset.label.passwordConfirmation') }}
          <AppInput
            v-model="passwordResetForm.form.password_confirmation"
            class="form-input"
            type="password"
            name="password_confirmation"
            :error="passwordResetForm.getErrors('password_confirmation')"
            required
          />
        </label>

        <button
          type="submit"
          class="btn btn--primary-blue"
        >
          {{ params.welcome ? $t('PasswordReset.button.setPassword') : $t('PasswordReset.button.resetPassword') }}
        </button>
      </form>

      <div
        v-else
        class="flex flex-col text-center"
      >
        <p class="text-green-600 font-semibold text-lg pt-10 pb-6">
          {{ params.welcome ? $t('PasswordReset.passwordSet') : $t('PasswordReset.passwordReset') }}
        </p>

        <RouterLink
          :to="{ name: 'Login' }"
          class="btn btn--primary-blue"
        >
          {{ $t('PasswordReset.button.logIn') }}
        </RouterLink>
      </div>

      <RouterLink
        :to="{ name: 'Login' }"
        class="btn btn--tertiary-blue ml-auto mt-10"
      >
        {{ $t('PasswordReset.button.logIn') }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFormData } from '@/composables/useFormData';
import AuthService from '@/services/AuthService';
import { ref } from 'vue';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

const passwordResetForm = useFormData({
  token: params.token,
  email: params.email,
  password: '',
  password_confirmation: '',
});

const success = ref(false);

const resetPassword = () => {
  AuthService.resetPassword(passwordResetForm.form).then(([data, error]) => {
    if(data) {
      success.value = true;

      return;
    }

    passwordResetForm.setErrors(error.data);
  });
};
</script>

<style scoped></style>
